import React from 'react';
import SessionActionsWrapper from './sessionSections/SessionInfo/SessionActionsWrapper';
import FeatureToggleUtils from 'FeatureToggleUtils';
import SessionDates from './sessionSections/SessionInfo/SessionDates';
import SessionTitle from './sessionSections/SessionInfo/SessionTitle';
import SessionAccessError from './sessionSections/SessionInfo/SessionAccessError';
import SessionLocation from './SessionLocation';
import SessionRate from './sessionSections/SessionInfo/SessionRate';
import SessionTags from './sessionSections/SessionInfo/SessionTags';
import SessionDescription from './sessionSections/SessionInfo/SessionDescription';
import JoinBroadcastButtonPreview from './sessionSections/virtualSession/JoinBroadcastButtonPreview';

export const SessionPageInfo = ({
    isRingAvailable,
    session,
    me,
    settings,
    eventUrls,
    showEmailLogin,
    toggleMarker,
    sessionViewType,
    toggleSessionRegistrationStatusPerSession,
    openCloseTicketSelectionPopUp,
    ticketsSelectionData,
    siteConf,
    setSessionFullRegistration,
    setLoginV2OffsetTop,
    isSessionRegistrationEnabled,
    event,
    setVirtualSessionDetails,
    setRecordUrl,
    setScrollToSessionBroadcastAction,
    showRegisterAndLoginModal,
    setLoginV2SpinnerOrigin,
    loginV2LoadingState,
    isWebLoginV2Used,
    accessErrorType,
    shouldUseCompactDescription = true,
    rate,
    feedback,
    sendRate,
}) => {
    const topOfSessionViewRef = React.useRef();
    const agendaVenueAlignmentEnabled = FeatureToggleUtils.isFeatureEnabled(
        'seshreg-agenda-venue-behavior-alignment'
    );

    const descriptionMaxHeight = sessionViewType === 'sessionPreviewWindow' ? 60 : 120;
    return (
        <div className={'session-info-container'} ref={topOfSessionViewRef}>
            {(!isRingAvailable || agendaVenueAlignmentEnabled) && (
                <SessionActionsWrapper
                    session={session}
                    settings={settings}
                    me={me}
                    eventUrls={eventUrls}
                    showEmailLogin={showEmailLogin}
                    toggleMarker={toggleMarker}
                    sessionViewType={sessionViewType}
                    toggleSessionRegistrationStatusPerSession={
                        toggleSessionRegistrationStatusPerSession
                    }
                    openCloseTicketSelectionPopUp={openCloseTicketSelectionPopUp}
                    ticketsSelectionData={ticketsSelectionData}
                    siteConf={siteConf}
                    event={event}
                    setSessionFullRegistration={setSessionFullRegistration}
                    setLoginV2OffsetTop={setLoginV2OffsetTop}
                />
            )}
            <SessionDates
                session={session}
                settings={settings}
                isSessionRegistrationEnabled={isSessionRegistrationEnabled}
                me={me}
                event={event}
                eventUrls={eventUrls}
                showEmailLogin={showEmailLogin}
                sessionViewType={sessionViewType}
            />
            <SessionTitle session={session} />
            {!isRingAvailable && (
                <JoinBroadcastButtonPreview
                    eventUrls={eventUrls}
                    session={session}
                    me={me}
                    showEmailLogin={showEmailLogin}
                    sessionViewType={sessionViewType}
                    event={event}
                    setVirtualSessionDetails={setVirtualSessionDetails}
                    siteConf={siteConf}
                    setScrollToSessionBroadcastAction={
                        setScrollToSessionBroadcastAction
                    }
                    setRecordUrl={setRecordUrl}
                    showRegisterAndLoginModal={showRegisterAndLoginModal}
                    ticketsSelectionData={ticketsSelectionData}
                />
            )}
            {!isRingAvailable && (
                <SessionAccessError
                    accessErrorType={accessErrorType}
                    session={session}
                    eventUrls={eventUrls}
                    siteConf={siteConf}
                    event={event}
                    setLoginV2SpinnerOrigin={setLoginV2SpinnerOrigin}
                    loginV2LoadingState={loginV2LoadingState}
                    isWebLoginV2Used={isWebLoginV2Used}
                    setLoginV2OffsetTop={setLoginV2OffsetTop}
                    onLoginClick={showEmailLogin}
                    ticketsSelectionData={ticketsSelectionData}
                />
            )}
            <SessionLocation session={session} />
            <SessionDescription
                session={session}
                topOfSessionViewRef={topOfSessionViewRef}
                shouldUseCompactDescription={shouldUseCompactDescription}
                descriptionMaxHeight={descriptionMaxHeight}
            />
            {!isRingAvailable && (
                <SessionRate
                    event={event}
                    rate={rate}
                    feedback={feedback}
                    settings={settings}
                    me={me}
                    eventUrls={eventUrls}
                    session={session}
                    showEmailLogin={showEmailLogin}
                    sendRate={sendRate}
                    setLoginV2OffsetTop={setLoginV2OffsetTop}
                    siteConf={siteConf}
                    sessionViewType={sessionViewType}
                />
            )}
            <SessionTags session={session} />
        </div>
    );
};
